import { DiscountCodeResponse } from "@/module/DiscountCode/DiscountCodeResponse";

export default class FindDiscountCode {
  private readonly formUrl: string;
  private readonly path: string;

  constructor(apiUrl: string, path: string) {
    this.formUrl = apiUrl;
    this.path = path;
  }

  get(code: string): Promise<DiscountCodeResponse> {
    return fetch(
      this.formUrl +
        "/is-discount-code-valid?id=" +
        this.path +
        "&code=" +
        code,
      {
        credentials: "omit",
      },
    ).then(function (result) {
      return result.json();
    });
  }
}
